
import Cookies from "js-cookie";

const SESSION_KEY = "user_session";

export const getUserSession = <T = Record<string, unknown>>(): T | null => {
  if (typeof window === "undefined") return null;

  try {
    const localData = localStorage.getItem(SESSION_KEY);
    if (!localData) return null;

    const parsed = JSON.parse(localData);
    
   
    if (parsed && typeof parsed === "object" && Object.keys(parsed).length > 0) {
      return parsed as T;
    }
  } catch (error) {
    console.error("Gagal parse user_session dari localStorage:", error);
  }

  return null;
};

export const setUserSession = (data: unknown) => {
  if (typeof window !== "undefined") {
    localStorage.setItem(SESSION_KEY, JSON.stringify(data));
    Cookies.remove(SESSION_KEY, { path: "/" });
  }
};

export const clearUserSession = () => {
  if (typeof window !== "undefined") {
    localStorage.removeItem(SESSION_KEY);
    localStorage.removeItem("user-storage");
    localStorage.removeItem("token");
    sessionStorage.clear(); 
    Cookies.remove(SESSION_KEY, { path: "/" });
    Cookies.remove("auth_token", { path: "/" });
    Cookies.remove("auth_token");
  }
};